import { ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import { collapseAnimation } from './filters-section.animations';

@Component({
    selector: 'no-kno-filters-section',
    templateUrl: './filters-section.component.html',
    styleUrls: ['./filters-section.component.scss'],
    animations: [ collapseAnimation ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiltersSectionComponent implements OnInit {

  @Input() title!: string;
  @Input() single = false;
  @Input() open = false;
  @Input() showBadge = false;
  @Input() badgeCount = 0;
  animationParams = {paddingBottom: '16px'};

  // Flag to track if user has interacted with this section
  public hasUserInteracted = false;

  constructor() {
  }

  ngOnInit(): void {
    this.animationParams.paddingBottom = this.single ? '0px' : '16px';
  }

  onHeaderClick(): void {
    this.open = !this.open;
    this.hasUserInteracted = true;
  }

}
